import React, { useCallback, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faSave, faTimes, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { useForm } from 'react-hook-form';
import service from '../../../services/usuarios';
import serviceIti from '../../../services/itinerarios';
import { actions as actionsSite } from './../../../redux/actions/site';
import { useHistory, useParams } from 'react-router';
import { buscaEndereco, hasText, isCEP, isCPF, isDate, isEmail, maskDate } from '../../../utils/utils';
import CheckBox from '../form/generics/CheckBox';
import { useDispatch } from 'react-redux';
import { formatCurrency } from '../../../utils/Money';
import './UsuariosForm.scss';
import { date2Front } from '../../../utils/converts';
import UploadS3 from '../../../components/uploadS3/UploadS3';

const UsuariosForm = props => {

    const history = useHistory();
    const params = useParams();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [registro, setRegistro] = useState({});
    const [itinerarios, setItinerarios] = useState([]);
    const [telefones, setTelefones] = useState([]);
    const [enderecos, setEnderecos] = useState([]);
    const [documentos, setDocumentos] = useState([]);
    const { register, handleSubmit, setValue, errors, getValues, setError } = useForm();

    const baseTelefoneObj = {
        _id: null,
        tipo: "celular",
        ddd: "",
        numero: "",
        contato: "",
        principal: false
    }

    const baseDocumentoObj = {
        _id: null,
        descricao: "",
        nome: "",
        tipo: "",
        url: ""
    }

    const baseEnderecoObj = {
        _id: null,
        tipo: "residencial",
        endereco: "",
        numero: "",
        complemento: "",
        pontoReferencia: "",
        bairro: "",
        cidade: "",
        uf: "",
        cep: "",
        isBoleto: false
    }

    const changeScore = e => {
        const val = e.target.value + "00";
        const newValue = formatCurrency(val);
        setValue('limite', newValue);
        document.querySelector("#limite").classList.add('hasText');
    }

    const changeValueMoney = (e, campo) => {
        const value = e.target.value;
        const newValue = formatCurrency(value);
        setValue(campo, newValue);
        document.querySelector("#" + campo).classList.add('hasText');
    }
    const changeItinerario = e => {
        const _registro = { ...registro };
        _registro.itinerario = e.target.value;
        setRegistro(_registro);
    }

    const optionItinerarios = () => {
        const op = [...itinerarios];
        op.unshift({ _id: "", nome: "Selecione um Itinerário" });
        return op.map((o, i) => {
            return <option key={i} value={o._id}>{o.nome}</option>;
        });
    }

    const setDiaPagamento = (dia, checked) => {
        const _registro = { ...registro };
        if (!_registro.diasPagamento) {
            _registro.diasPagamento = [];
        }
        if (_registro.diasPagamento.includes(dia)) {
            const index = _registro.diasPagamento.indexOf(dia);
            _registro.diasPagamento.splice(index, 1);
        } else {
            _registro.diasPagamento.push(dia);
        }
        setRegistro(_registro);
    }

    const renderDiasCheckbox = () => {
        const rangeDias = new Array(31).fill(1).map((e, i) => (i + 1));

        return rangeDias.map((dia, index) => {
            return <CheckBox key={index} label={dia} value={dia} callback={setDiaPagamento} checked={registro.diasPagamento?.includes(dia)} />
        });
    }

    const addField = p => {
        const base = {
            label: p.label || "",
            field: p.field || "",
            type: 'input',
            index: "",
            customValue: false,
            objValue: p.objValue || {},
            validations: p.validations || null
        };
        const params = { ...base, ...p };
        const ret = renderField(params);
        return ret;
    }

    const renderField = p => {
        switch (p.type) {
            case 'input':
                return renderInput(p);
            case 'password':
                return renderPassword(p);
            case 'select':
                return renderSelect(p);
            default:
                return null;
        }
    }
    const changeValueField = (obj, field, value, cb = null) => {
        obj[field] = value;
        if (cb) {
            cb();
        }
    }

    const resetTelefones = () => {
        const _telefones = [...telefones];
        setTelefones(_telefones);
    }
    const resetEnderecos = () => {
        const _enderecos = [...enderecos];
        setEnderecos(_enderecos);
    }

    const renderSelect = p => {
        const id_name = `${p.field}${p.index}`;
        return (
            <div className={errors[id_name] ? "field error" : "field"}>
                {p.customValue &&
                    <select name={id_name} id={id_name} className={"hasText"} ref={register(p.validations)}
                        onChange={(e) => changeValueField(p.objValue, p.field, e.target.value, p.customValue.callback)} value={p.objValue[p.field]}>
                        {/* <option value="">Selecione...</option> */}
                        {
                            p.options.map((item, index) => {
                                if (typeof item === 'object') {
                                    return <option value={item.value} key={index}>{item.label}</option>;
                                } else {
                                    return <option value={item} key={index}>{item}</option>;
                                }
                            })
                        }
                    </select>
                }
                {!p.customValue &&
                    <select name={id_name} id={id_name} className={"hasText"} ref={register(p.validations)} defaultValue={p.objValue[p.field]}>
                        {/* <option value="">Selecione...</option> */}
                        {
                            p.options.map((item, index) => {
                                if (typeof item === 'object') {
                                    return <option value={item.value} key={index}>{item.label}</option>;
                                } else {
                                    return <option value={item} key={index}>{item}</option>;
                                }
                            })
                        }
                    </select>
                }
                <label htmlFor={id_name}>{p.label}</label>
            </div>
        );
    }

    const renderInput = p => {
        const id_name = `${p.field}${p.index}`;
        return (
            <div className={errors[id_name] ? "field error" : "field"}>
                {p.customValue &&
                    <input name={id_name} id={id_name} type="text"
                        className={p.objValue[p.field] && p.objValue[p.field] !== "" ? "hasText" : ""}
                        onKeyUp={(e) => hasText(e)} ref={register(p.validations)}
                        value={p.objValue[p.field] || ""}
                        onChange={(e) => {
                            if (p.change) {
                                p.change(e.target.value, p.changeArgs);
                            }
                            changeValueField(p.objValue, p.field, e.target.value, p.customValue.callback);
                        }
                        } />
                }
                {!p.customValue &&
                    <input name={id_name} id={id_name} type="text"
                        className={p.objValue[p.field] && p.objValue[p.field] !== "" ? "hasText" : ""}
                        onKeyUp={(e) => hasText(e)} ref={register(p.validations)}
                        defaultValue={p.convert ? p.convert(p.objValue[p.field]) : p.objValue[p.field]}
                        onChange={(e) => {
                            if (p.change) {
                                p.change(e.target.value, p.changeArgs);
                            }
                        }}
                    />
                }
                <label htmlFor={id_name}>{p.label}</label>
            </div>
        );
    }

    const renderPassword = p => {
        const id_name = `${p.field}${p.index}`;
        return (
            <div className={errors[id_name] ? "field error" : "field"}>
                <input name={id_name} id={id_name} type="password"
                    className={p.objValue[p.field] && p.objValue[p.field] !== "" ? "hasText" : ""}
                    onKeyUp={(e) => hasText(e)} ref={register(p.validations)}
                    value={p.objValue[p.field]}
                />
                <label htmlFor={id_name}>{p.label}</label>
            </div>
        );
    }


    const addBreak = () => {
        return <div className="break"></div>;
    }

    const buttonAdd = action => {
        return (
            <div className="field botaoAdd">
                <button type="button" onClick={action}><FontAwesomeIcon icon={faPlus} /></button>
            </div>
        );
    }

    const buttonRmv = (index, action) => {

        return (
            <div className="field botaoRmv">
                <button type="button" onClick={() => action(index)}><FontAwesomeIcon icon={faTrash} /></button>
            </div>
        );

    }

    const rmvDocumento = (index) => {
        const _documentos = [...documentos];
        const obj = _documentos[index];
        if (obj._id && obj._id !== "") {
            openModalRemoveDocumento(index, obj._id);
        } else {
            rmvItemDocumento(index);
        }
    }

    const rmvItemDocumento = (index) => {
        const _documentos = [...documentos];
        _documentos.splice(index, 1);
        setDocumentos(_documentos);
    }

    const removerDocumento = async arg => {
        const { index, id } = arg;
        dispatch(actionsSite.setModal(null));
        dispatch(actionsSite.setLoadingMsg("Excluindo documento..."));
        const res = await service.excluirDocumento(id);
        dispatch(actionsSite.setLoadingMsg(res.msg));
        setTimeout(() => {
            rmvItemDocumento(index);
            dispatch(actionsSite.setLoadingMsg(""));
        }, 3000);
    }

    const openModalRemoveDocumento = (index, id) => {
        const configModal = {
            msg: `Tem certeza que deseja excluir esse documento?`, title: "Excluir documento",
            actions: [
                { label: "Sim", class: "azul", callback: removerDocumento, arg: { index, id } },
            ]
        }

        dispatch(actionsSite.setModal(configModal))
    }   

    const openModalRemoveEndereco = (index, id) => {
        const configModal = {
            msg: `Tem certeza que deseja excluir esse endereço?`, title: "Excluir endereço",
            actions: [
                { label: "Sim", class: "azul", callback: removerEndereco, arg: { index, id } },
            ]
        }

        dispatch(actionsSite.setModal(configModal))
    }

    const addTitulo = titulo => {
        return <h3 className="tituloEtapa mt20">{titulo}</h3>;
    }

    const renderFormTelefones = () => {
        if (telefones.length < 1) {
            addTelefone();
        }
        return telefones.map((e, index) => (<React.Fragment key={index}>{renderTelefone(index, e)} {addBreak()}</React.Fragment>));
    }

    const renderTelefone = (index, obj) => {
        const items = [
            addField({ index, label: "Tipo", field: "tipo", type: 'select', options: ["celular","celular (whatsapp)", "recado", "residencial"], objValue: obj, customValue: { callback: resetTelefones } }),
            addField({ index, label: "DDD", field: "ddd", objValue: obj, customValue: { callback: resetTelefones } }),
            addField({ index, label: "Número", field: "numero", objValue: obj, customValue: { callback: resetTelefones } }),
            addField({ index, label: "Nome contato", field: "contato", objValue: obj, customValue: { callback: resetTelefones } }),
            buttonAdd(addTelefone),
            buttonRmv(index, rmvTelefone)
        ];
        return items.map((e, i) => (<React.Fragment key={i}>{e}</React.Fragment>));

    }

    const addTelefone = () => {
        const _telefones = [...telefones];
        _telefones.push(baseTelefoneObj);
        setTelefones(_telefones);
    }

    const rmvTelefone = (index) => {
        const _telefones = [...telefones];
        const obj = _telefones[index];
        if (obj._id && obj._id !== "") {
            openModalRemoveTelefone(index, obj._id);
        } else {
            rmvItemTelefone(index);
        }
    }

    const rmvItemTelefone = (index) => {
        const _telefones = [...telefones];
        _telefones.splice(index, 1);
        setTelefones(_telefones);
    }

    const removerTelefone = async arg => {
        const { index, id } = arg;
        dispatch(actionsSite.setModal(null));
        dispatch(actionsSite.setLoadingMsg("Excluindo telefone..."));
        const res = await service.excluirTelefone(id);
        dispatch(actionsSite.setLoadingMsg(res.msg));
        setTimeout(() => {
            rmvItemTelefone(index);
            dispatch(actionsSite.setLoadingMsg(""));
        }, 3000);
    }

    const openModalRemoveTelefone = (index, id) => {
        const configModal = {
            msg: `Tem certeza que deseja excluir esse telefone?`, title: "Excluir telefone",
            actions: [
                { label: "Sim", class: "azul", callback: removerTelefone, arg: { index, id } },
            ]
        }

        dispatch(actionsSite.setModal(configModal))
    }

    const addEndereco = () => {
        const _enderecos = [...enderecos];
        if (_enderecos.length === 0){
            baseEnderecoObj.isBoleto = true;
        }
        _enderecos.push(baseEnderecoObj);
        setEnderecos(_enderecos);
    }

    const rmvEndereco = (index) => {
        const _enderecos = [...enderecos];
        const obj = _enderecos[index];
        if (obj._id && obj._id !== "") {
            openModalRemoveEndereco(index, obj._id);
        } else {
            rmvItemEndereco(index);
        }
    }

    const rmvItemEndereco = (index) => {
        const _enderecos = [...enderecos];
        _enderecos.splice(index, 1);
        setEnderecos(_enderecos);
    }

    const removerEndereco = async arg => {
        const { index, id } = arg;
        dispatch(actionsSite.setModal(null));
        dispatch(actionsSite.setLoadingMsg("Excluindo endereço..."));
        const res = await service.excluirEndereco(id);
        dispatch(actionsSite.setLoadingMsg(res.msg));
        setTimeout(() => {
            rmvItemEndereco(index);
            dispatch(actionsSite.setLoadingMsg(""));
        }, 3000);
    }

    const renderFormEnderecos = () => {
        if (enderecos.length < 1) {
            addEndereco();
        }
        return enderecos.map((e, index) => (<React.Fragment key={index}>{renderEndereco(index, e)} {addBreak()}</React.Fragment>));
    }
    
    const renderEndereco = (index, obj) => {
        const items = [
            // buttonAdd(addEndereco),
            // buttonRmv(index, rmvEndereco),
            //addBreak(),
            addField({
                index, label: "CEP", field: "cep", objValue: obj, customValue: { callback: resetEnderecos },
                validations: { required: true, validate: { isNumeric: value => !isNaN(value) } },
                change: getAddress, changeArgs: index
            }),
            addField({ index, label: "Tipo", field: "tipo", type: 'select', options: ["residencial", "entrega"], objValue: obj, customValue: { callback: resetEnderecos } }),
            addBreak(),
            addField({ index, label: "Endereço", field: "endereco", validations: { required: true }, objValue: obj, customValue: { callback: resetEnderecos } }),
            addField({ index, label: "Nº", field: "numero", objValue: obj, customValue: { callback: resetEnderecos } }),
            addField({ index, label: "Complemento", field: "complemento", objValue: obj, customValue: { callback: resetEnderecos } }),
            addBreak(),
            addField({ index, label: "Ponto de referência", field: "pontoReferencia", objValue: obj, customValue: { callback: resetEnderecos } }),
            addBreak(),
            addField({ index, label: "Bairro", field: "bairro", validations: { required: true }, objValue: obj, customValue: { callback: resetEnderecos } }),
            addField({ index, label: "Cidade", field: "cidade", validations: { required: true }, objValue: obj, customValue: { callback: resetEnderecos } }),
            addField({ index, label: "UF", field: "uf", validations: { required: true }, objValue: obj, customValue: { callback: resetEnderecos } }),

        ];

        return (
            <div className="bloco">
                <div className="acoes">
                    <CheckBox label="Aparece no Boleto" value="isBoleto" reload={true} callback={flagApareceBoleto} callbackArgs={index} checked={obj.isBoleto} />
                    {buttonAdd(addEndereco)}
                    {buttonRmv(index, rmvEndereco)}
                </div>
                {addBreak()}
                {
                    items.map((e, i) => {
                        return <React.Fragment key={i}>{e}</React.Fragment>;
                    })
                }
            </div>
        )

    }

    const renderSenhas = () => {
        if (!params.id) {
            return (
                <>
                    {addTitulo('Acesso ao portal')}
                    {addField({ label: "Senha", field: "senha", type: 'password', validations: { required: true } })}
                    {addField({ label: "Confirmar senha", field: "confSenha", type: 'password', validations: { required: true, validate: value => value === getValues("senha") } })}
                    {addBreak()}
                </>
            )
        }
    }

    const flagRegistro = (campo, checked) => {
        setValue(campo, checked);
    }

    const flagApareceBoleto = (campo, checked, index) => {
        if(window.confirm("Deseja mesmo fazer a alteração?")){

            const _enderecos = [...enderecos];
            _enderecos[index]["isBoleto"] = checked;
            if (checked) {
                for (let x = 0; x < _enderecos.length; x++) {
                    if (x !== index) {
                        _enderecos[x]["isBoleto"] = false;
                    }
                }
            }
            setEnderecos(_enderecos);
        }
    }

    const renderDataNascimento = () => {
        return (
            <div className={errors.dataNascimento ? "field error" : "field"}>
                <input name="dataNascimento" id="dataNascimento" maxLength={10}
                    className={registro.dataNascimento && registro.dataNascimento !== "" ? "hasText" : ""} onKeyUp={(e) => { maskDate(e); hasText(e) }} type="text"
                    ref={register({ required: true, validate: { isDate: value => isDate(value) } })} defaultValue={date2Front(registro.dataNascimento)} />
                <label htmlFor="dataNascimento">Data de Nascimento</label>
            </div>
        );
    }

    const renderAprovacao = () => {
        return (
            <>
                {addTitulo('Cŕedito e preferências')}
                <div className={errors.score ? "field error" : "field"}>
                    <input className={registro.score ? 'hasText' : ''} name="score" id="score"
                        onKeyUp={(e) => hasText(e)}
                        maxLength={4}
                        ref={register({ validate: { isNumeric: value => !isNaN(value) } })}
                        onChange={changeScore} defaultValue={registro.score} type="text" />
                    <label htmlFor="score">Score</label>
                </div>

                <div className={errors.scoreDataConsulta ? "field error" : "field"}>
                    <input className={registro.scoreDataConsulta ? 'hasText' : ''} name="scoreDataConsulta" id="scoreDataConsulta"
                        maxLength={10} onKeyUp={(e) => { maskDate(e); hasText(e) }}
                        ref={register({ validate: { erroData: value => isDate(value) } })}
                        defaultValue={date2Front(registro.scoreDataConsulta)}
                        type="text" />
                    <label htmlFor="scoreDataConsulta">Data Consulta</label>
                </div>
                <div className={errors.scoreNumeroResposta ? "field error" : "field"}>
                    <input className={registro.scoreNumeroResposta ? 'hasText' : ''} name="scoreNumeroResposta" id="scoreNumeroResposta"
                        onKeyUp={(e) => hasText(e)} ref={register()} defaultValue={registro.scoreNumeroResposta} type="text" />
                    <label htmlFor="scoreNumeroResposta">Nº Resposta</label>
                </div>
                <div className="break"></div>
                <div className={errors.limite ? "field error" : "field"}>
                    <input className={registro.limite ? 'hasText' : ''} name="limite" id="limite"
                        onKeyUp={(e) => { hasText(e) }}
                        onChange={(e) => { changeValueMoney(e, 'limite') }}
                        ref={register()}
                        defaultValue={formatCurrency(registro.limite)} type="text" />

                    <label htmlFor="limite">Valor aprovado R$</label>
                </div>

                <div className={errors.taxaManuseio ? "field error" : "field"}>
                    <input className={registro.taxaManuseio ? 'hasText' : ''} name="taxaManuseio" id="taxaManuseio"
                        onKeyUp={(e) => { hasText(e) }}
                        onChange={(e) => { changeValueMoney(e, 'taxaManuseio') }}
                        ref={register()}
                        defaultValue={formatCurrency(registro.taxaManuseio)} type="text" />

                    <label htmlFor="taxaManuseio">Valor frete R$</label>
                </div>

                <div className={errors.itinerario ? "field error" : "field"}>
                    <select name="itinerario" className="hasText" ref={register()} id="itinerario"
                        value={registro.itinerario || ""} onChange={(e) => changeItinerario(e)}>
                        {optionItinerarios()}
                    </select>
                    <label htmlFor="itinerario">Itinerário</label>
                </div>
                <div className="break"></div>
                {addTitulo('Anotações')}
                <div className="anotacoes">
                    {registro.anotacoes &&
                        registro.anotacoes.map((item, index) => {
                            return <div className={"itemAnotacao"} key={index} dangerouslySetInnerHTML={{ __html: item }}></div>
                        })
                    }
                    <div className="field">
                        <textarea name="anotacoes" className="" ref={register()} onKeyUp={(e) => { hasText(e) }} id="anotacoes"></textarea>
                        <label htmlFor="anotacoes">Nova Anotação</label>
                    </div>
                </div>
                <div className="break"></div>

                <h3 className="tituloEtapa mt20">Dia de pagamento</h3>
                <div className="break"></div>
                <input name="diasPagamento" value={registro.diasPagamento?.join(',')} id="diasPagamento" type="hidden" ref={register()} />
                {renderDiasCheckbox()}
                <div className="break"></div>

                <h3 className="tituloEtapa mt20">Meios de pagamento</h3>
                <div className="break"></div>
                <input type="checkbox" className="hidden" name="pagamentoAvista" defaultChecked={registro.pagamentoAvista} ref={register()} />
                <input type="checkbox" className="hidden" name="pagamentoFaturado" defaultChecked={registro.pagamentoFaturado} ref={register()} />
                <input type="checkbox" className="hidden" name="pagamentoCartao" defaultChecked={registro.pagamentoCartao} ref={register()} />
                <CheckBox label="Á Vista" value="pagamentoAvista" callback={flagRegistro} checked={registro.pagamentoAvista} />
                <CheckBox label="Fatura" value="pagamentoFaturado" callback={flagRegistro} checked={registro.pagamentoFaturado} />
                <CheckBox label="Cartão" value="pagamentoCartao" callback={flagRegistro} checked={registro.pagamentoCartao} />
                <div className="break"></div>
            </>
        );
    }

    const setDocumento = (fileParams, returnS3) => {
        const _documentos = [...documentos];
        const documento = {
            ...baseDocumentoObj,
            nome: fileParams.name,
            tipo: fileParams.ext,
            url: returnS3.Location
        }
        _documentos.push(documento);
        setDocumentos(_documentos);
    }

    const changeDescricaoDocumento = (e, index) => {
        const _documentos = [...documentos];
        _documentos[index]["descricao"] = e.target.value;
        setDocumentos(_documentos);
    }

    const renderItemsDocumentos = () => {
        return documentos.map((doc, index) => {
            return <div className="item fileurl" key={index}>
                <div className="input"><input defaultValue={doc.descricao} onChange={(e) => changeDescricaoDocumento(e, index)} placeholder="descrição do documento..." /></div>
                <div className="url"><a href={doc.url} target="_blank" rel="noopener noreferrer">{doc.nome}</a></div>
                <div className="icon" onClick={() => rmvDocumento(index)}><FontAwesomeIcon icon={faTrash} /></div>
            </div>
        })

    }

    const renderDocumentos = () => {
        return (
            <div className="field documentos">
                {renderItemsDocumentos()}
                <UploadS3 bucket="lekamedia" folder="documentos" extensions={['pdf', 'jpg', 'jpeg', 'png']} callback={setDocumento} label="Clique para enviar um novo documento" />
            </div>
        );
    }

    const renderForm = () => {
        const items = [
            addField({ label: "Nome", field: "nome", objValue: registro, validations: { required: true } }),
            addBreak(),
            addField({ label: "CPF", field: "cpf", objValue: registro, validations: { required: true, validate: { isCPF: value => isCPF(value) } } }),
            addField({ label: "E-mail", field: "email", objValue: registro, validations: { required: true, validate: { isEmail: value => isEmail(value) } } }),
            addBreak(),
            renderDataNascimento(),
            //addField({ label: "Data de nascimento", field: "dataNascimento", validations: { required: true }, objValue: registro, convert: date2Front }),
            addField({ label: "Gênero", field: "genero", type: 'select', options: [{ value: "F", label: "Feminino" }, { value: "M", label: "Masculino" }], validations: { required: true }, objValue: registro }),
            addField({ label: "RG", field: "rg", objValue: registro }),
            addField({ label: "Órgão emissor", field: "orgaoEmissor", objValue: registro }),
            addBreak(),
            addField({ label: "Nome da mãe", field: "nomeMae", objValue: registro, validations: { required: true } }),
            addField({ label: "Nome do pai", field: "nomePai", objValue: registro }),
            renderSenhas(),
            addTitulo('Telefones'),
            renderFormTelefones(),
            addTitulo('Endereços'),
            renderFormEnderecos(),
            addBreak(),
            addTitulo('Documentos'),
            renderDocumentos(),
            addBreak(),
            addTitulo('Outras informações'),
            addField({
                label: "Como conheceu?", field: "comoConheceu", objValue: registro, type: 'select',
                options: ['Indicação', 'Já sou Consultor(a)', 'Facebook', 'Google', 'Outras mídias']
            }),
            addField({ label: "Quem indicou?", field: "quemIndicou", objValue: registro }),
            addBreak(),
            addField({ label: "Observação", field: "observacoes", objValue: registro }),
            renderAprovacao(),
        ];

        return items.map((e, i) => (<React.Fragment key={i}>{e}</React.Fragment>));
    }

    const carregarDados = useCallback(async (id) => {
        const rowsIti = await serviceIti.getList({ sort: 'nome' });
        setItinerarios(rowsIti.rows);
        if (id) {
            const row = await service.getById(id);
            setRegistro(row);
            setTelefones(row.telefones);
            setEnderecos(row.enderecos);
            setDocumentos(row.documentos);
        }
        setLoading(false);
    }, []);

    useEffect(() => {
        carregarDados(params.id);
    }, [carregarDados, params.id]);

    const getAddress = async (cep, index) => {
        try {
            if (isCEP(cep)) {
                const address = await buscaEndereco(cep);
                if (address) {
                    const obj = enderecos[index];
                    changeValueField(obj, 'endereco', address.street);
                    changeValueField(obj, 'bairro', address.neighborhood);
                    changeValueField(obj, 'cidade', address.city);
                    changeValueField(obj, 'uf', address.state, resetEnderecos);
                }
            }
        } catch (e) {
            setError("cep", {
                type: "invalid",
            });
        }
    }

    const salvar = async (data) => {
        data["telefones"] = telefones;
        data["enderecos"] = enderecos;
        data["documentos"] = documentos;
        dispatch(actionsSite.setLoadingMsg("Enviando dados..."));
        let res;
        if (params.id) {
            res = await service.atualizarUsuario(params.id, data);
            dispatch(actionsSite.setLoadingMsg(res.msg));
        } else {
            res = await service.cadastroRevendedora(data);
            dispatch(actionsSite.setLoadingMsg(res.msg));
        }

        setTimeout(() => {
            dispatch(actionsSite.setLoadingMsg(""));
            if (!params.id && !res.erro) {
                history.push('/painel/usuarios');
            } else {
                if (!res.erro) {
                    setLoading(true);
                    carregarDados(params.id);
                }
            }
        }, 3000);
    }

    return (
        <>
            {!loading &&
                <div className="form usuarios">
                    <form onSubmit={handleSubmit(salvar)} className="formModule branco">
                        <div className="break"></div>
                        <div className="acoes">
                            <button type="submit" className="salvar"><FontAwesomeIcon icon={faSave} /> {params.id ? 'Editar' : 'Salvar'}</button>
                            <button type="button" className="cancelar" onClick={() => history.goBack()}><FontAwesomeIcon icon={faBan} /> Cancelar</button>
                        </div>
                        <div className="break"></div>
                        {renderForm()}
                        <div className="break"></div>
                        <div className="acoes">
                            <button type="submit" className="salvar"><FontAwesomeIcon icon={faSave} /> {params.id ? 'Editar' : 'Salvar'}</button>
                            <button type="button" className="cancelar" onClick={() => history.goBack()}><FontAwesomeIcon icon={faBan} /> Cancelar</button>
                        </div>
                        <div className="break"></div>
                    </form>
                    {errors && Object.keys(errors).length > 0 &&
                        <div className="erros">
                            <div><FontAwesomeIcon icon={faTimes} /> Existem erros no formulário</div>
                        </div>
                    }
                </div>
            }

            {loading && "Carregando..."}
        </>
    )
}

export default UsuariosForm;